export const RECEIVE_LOAN = 'RECEIVE_LOAN';
export const FETCHING_LOAN = 'FETCHING_LOAN';
export const FAILED_FETCHING_LOAN = 'FAILED_FETCHING_LOAN';
export const UPDATING_INCOME_SOURCE = 'UPDATING_INCOME_SOURCE';
export const UPDATED_INCOME_SOURCE = 'UPDATED_INCOME_SOURCE';
export const FAILED_UPDATING_INCOME_SOURCE = 'FAILED_UPDATING_INCOME_SOURCE';
export const SELECTED_INCOME_SOURCE = 'SELECTED_INCOME_SOURCE';
